import { setStatus } from 'shared/regions/slices/formSlice';
import { EStatus } from 'shared/common/types/form';
import { TThunk } from 'shared/common/types/thunk';

export const setCallbackInit = (): TThunk => dispatch => {
  dispatch(setStatus(EStatus.Initial));
};
